(function () {
    'use strict';
    app.controller('contactUsController', ['$scope', 'LoginService', '$location', '$cookies', 'AuthenticationService', 'progressBarService', 'contactUsservice', '$rootScope', '$timeout', '$compile', function ($scope, loginService, $location, $cookies, AuthenticationService, progressBarService, contactUsservice, $rootScope, $timeout, $compile) {

        $scope.reloadCaptcha = function () {
            $rootScope.$broadcast('reloadCaptcha', {});
        }

        $scope.reloadCaptcha();

        $scope.submitMessage = function (userData) {
            $scope.sendFeedbackMailToEspectra(userData);
        }

        $scope.sendFeedbackMailToEspectra = function (userData) {
            progressBarService.showProgressBar();
            contactUsservice.sendContactFormToEspectra(userData);
            $timeout(function () {
                progressBarService.hideProgressBar();
                $scope.isSuccess = true;
                $scope.message = "Contact form has been submitted successfully.";
            }, 1000);
            $scope.reloadCaptcha();
            $scope.userData.username = '';
            $scope.userData.emailId = '';
            $scope.userData.message = '';
            $scope.contatcUsForm.$setPristine();
            $scope.contatcUsForm.$setUntouched();
        }
    }]);
})();
